// extracted by mini-css-extract-plugin
module.exports = {"quizMobileMinInnerHeight":"436px","quizDesktopMinInnerHeight":"645px"};